export type ClipCardBodyAction = 'open' | 'select' | null;

/**
 * What a click on a clip card's open space means — the space outside its own
 * controls (title rename, dropdowns, badges, kebab, the thumbnail's pick box).
 *
 * Opening the clip, until a selection exists; then picking, so a run of picks
 * can be made across the card bodies once the first one came from the pick box
 * (the Photos pattern). Picking from a bare click used to work with nothing
 * selected too, which turned a stray click into a pick and a Delete button.
 *
 * A card that can't join the selection still opens during one: picking it is
 * not on offer, and opening is the only thing the click can mean. `null` while
 * the clip is still saving and editing it is blocked.
 */
export function clipCardBodyAction({
  selectable,
  selectionActive,
  isEditingBlocked,
}: {
  selectable: boolean;
  selectionActive: boolean;
  isEditingBlocked: boolean;
}): ClipCardBodyAction {
  if (selectable && selectionActive) return 'select';
  if (isEditingBlocked) return null;
  return 'open';
}
